var LibraryFactory = require('../library').instance;

module.exports = {
  initialize: function () {
    var deferred = $.Deferred();
    LibraryFactory.get('fonts').then(_.bind(
      this._onDataLoaded, this, deferred
    ));

    return deferred;
  }
};
